export const all = "all";
export const SEARCH = "SEARCH";
export const ADDTOCART = "ADDTOCART";
export const REMOVEPRODUCT = "REMOVEPRODUCT";
export const INCREASEPRODUCT = "INCREASEPRODUCT";
export const DECREASEPRODUCT = "DECREASEPRODUCT";
export const CLEARCART = "CLEARCART";
export const ADDUSER = "ADDUSER";
export const LOGINAUTHENTICATION = "LOGINAUTHENTICATION";
export const SETUSER = "SETUSER";
export const LOGOUT = "LOGOUT";
export const TOTALPRODUCT = "TOTALPRODUCT";
